module.exports = __webpack_public_path__ + "img/table_bottom_shadow_bgpng.1f334385.png";